module.exports = __webpack_public_path__ + "img/drone-lazy.1712f4ba.jpg";